module.exports = __webpack_public_path__ + "static/media/dollar-red.217e3061.svg";